export default function Terms() {
  return (
    <section className="mx-auto max-w-3xl px-6 py-6 sm:py-8">
      <p className="flex flex-col items-center gap-3 text-center text-sm text-muted-foreground sm:flex-row sm:justify-center sm:gap-0">
        <span>Free to start</span>
        <span className="hidden px-3 text-xl text-spark-purple sm:inline">
          •
        </span>
        <span>Bring your API keys</span>
        <span className="hidden px-3 text-xl text-spark-purple sm:inline">
          •
        </span>
        <span>Scale when you’re ready</span>
      </p>
    </section>
  )
}
